import { Cone, Ring, Sphere } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { Box } from "@react-three/flex";
import { reflectAll } from "async";
import { useRef } from "react";

function GeoFlex({
  scale,
  color,
  sphere,
  invert,
  rotate,
  spin,
  solid,
  cone
}) {

  const coneRef = useRef();
  const ringRef = useRef();
  const sphereRef = useRef();
  
  rotate ? 
  useFrame(({clock}) => {
    const t = clock.getElapsedTime() / 3
    sphereRef.current.rotation.y = t
  }) : null

  spin ? 
  useFrame(({clock}) => {
    const t = clock.getElapsedTime() / 3
    geoRef.current.rotation.y = t
  }) : null

  return (
      <Box
        dir='column' 
        align='center' 
        justify='center' 
        width='100%'
        maxHeight='40%'
        height='auto'
        grow={1}
        margin={scale}
      >
        {sphere ?
        <Sphere
          ref={sphereRef}
          scale={scale}
        >
          <meshStandardMaterial 
            color={color} 
            wireframe={solid ? false : true}
          />
        </Sphere> : cone ?
        <Cone
          ref={coneRef} 
          scale={scale}
          rotation={[invert ? 0 : Math.PI, 0, 0]}
        >
          <meshStandardMaterial
            color={color} 
            wireframe={solid ? false : true}
          />
        </Cone> :
        <Ring
          ref={ringRef}
          scale={scale}        
        >
          <meshStandardMaterial
            color={color}
            wireframe={solid ? false : true}
          />
        </Ring>
        }
      </Box>
  );
};

export default GeoFlex;